import { useSelector } from 'react-redux';
import { Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { selectConfig } from '@app/redux/config';

import myversion from '../../../../../myversion.json';

export const Version = () => {
  const { t } = useTranslation('Footer');

  const { env } = useSelector(selectConfig);

  const showVersionHash = env !== 'PROD' && env !== 'PREPROD';

  return (
    <Txt variant="smallRegular" component="span" data-cy="footer-version">
      {t(showVersionHash ? 'versionHash' : 'version', {
        versionNumber: myversion.version,
        hash: myversion.hash,
      })}
    </Txt>
  );
};
